import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3n88yzphkb: FaireBrandEntity = {
  token: "b_3n88yzphkb",
  type: "brand",
  name: "UZ Wholesale Store",
  avatarUrl:
    "https://cdn.faire.com/fastly/75246d4ea447cfbe33e29cc534fb93564cac9a878b939d7f3edd642c88a2433d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/851bdb3e63ce0fe0de1a3d111528baedd4c97c2aadf30afeafe99913815d8bec.png",
  logoUrl:
    "https://cdn.faire.com/fastly/75246d4ea447cfbe33e29cc534fb93564cac9a878b939d7f3edd642c88a2433d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/851bdb3e63ce0fe0de1a3d111528baedd4c97c2aadf30afeafe99913815d8bec.png",
  location: "WY, USA",
  minimumOrderDollars: 150,
  rating: 3.9,
  reviewCount: 548,
  isInsider: true,
  description:
    "Friendly reminder: Our price includes tax, and there will be no additional tax charges. \n\nAt Koopros, we believe less is more. Our philosophy celebrates the beauty of simplicity, embracing minimalism in fashion. More than an online store, we are a destination for those who appreciate refined style.\n\nOur journey began with a vision to redefine fashion. Born from a passion for clean lines, quality materials, and timeless designs, we curate clothing and accessories that embody the essence of minimalism. Each piece is thoughtfully crafted to be versatile, offering timeless staples and statement items that complement your style with understated elegance.\n\nWe are committed to sustainability and ethical practices, sourcing from eco-conscious manufacturers to ensure your fashion choices align with your values. At Koopros, simplicity is the ultimate sophistication. Join us in embracing the beauty of less and discover fashion that stands the test of time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:16.072Z",
    importedBy: "entity-db-cli",
  },
};
